

import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Events } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mq_List } from '../mq_list/mq_list';
import { MSteps } from '../msteps/msteps';

import { Dashboard } from '../dashboard/dashboard';
import { Select_Button } from '../select_button/select_button';
import { Mj_Statistiche_Sfida } from '../mj_statistiche_sfida/mj_statistiche_sfida';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-mj_sfida',
  templateUrl: 'mj_sfida.html',
})
export class Mj_Sfida extends Util {
  pagine: any;
  user: any = {};
  mj: any;
  fasi: any;
  items: any = [];
  //itemExpandHeight = 150;
  itemExpandHeight = [];
  mqs: any = [];
  sfide: any = [];
  fasefake: any;
  lanciasfidaexpand: boolean = false;
  sfidante_username: string = '';
  mqsfida: any = {};
  livello: any;
  modalopened: boolean = false;
  // v;
  @ViewChild('allcontent') pagecontent: ElementRef;
  constructor(public navCtrl: NavController,public events:Events, public translate: TranslateService, public theme: EthemeProvider, public navParams: NavParams, injector: Injector, loading: LoadingController) {
    super(injector, loading);
    this.lanciasfidaexpand = false;
    this.modalopened = false;
    this.storage.get('user').then((user) => {
      //console.log(user.id);
      // this.GetRequest('me','',true,false).then((user:any)=>{ 
      this.user = user;
    })
    // console.log(this.navParams);
    this.fasefake = this.navParams.get('fasefake');
    // console.log(this.fasefake);

    this.mj = this.navParams.get('mj');

    this.translate.get(['sfide.SFIDERICEVUTE', 'sfide.SFIDEINATTESA', 'sfide.SFIDETERMINATE']).subscribe(v => {
      this.sfide = [{ nome: v['sfide.SFIDERICEVUTE'], expanded: false, sfide: [] },
      { nome: v['sfide.SFIDEINATTESA'], expanded: false, sfide: [] },
      { nome: v['sfide.SFIDETERMINATE'], expanded: false, sfide: [] }];
      if (this.fasefake != undefined) {
        this.GetRequest('microQuestFase', this.fasefake.id, false, false).then(data => {
          //console.log(data['MicroQuestList']);
          for (let i = 0; i < data['MicroQuestList'].length; i++) {
            if (data['MicroQuestList'][i]['tipo'] == 'Sfida')
              this.mqsfida = data['MicroQuestList'][i];
          }
        }).catch((e) => {
          //this.navCtrl.push(Mj_Detail,{mj:m});
          console.error(e)
        })
      }
    });

    this.refreshpage(this.mj);
    //console.log('---USER-sfide:', this.user);
    // this.refreshpage(this.mj);
    // this.translate.get(['sfide.LANCIOSFIDA', 'ATTENZIONE', 'sfide.INSUSERNAME', 'SI', 'ANNULLA']).subscribe(v => {
    //   this.v = v;
    // });
  }
  ionViewDidEnter() {
    // console.log('--------------SFIDE----------');
    // this.refreshpage(this.mj);
  }
  ngOnInit(): void {
    
  }
  refreshpage(mj) {
    this.sfide[1].sfide = [];
    this.sfide[2].sfide = [];
    this.sfide[0].sfide = [];
    this.GetRequest('sfideList', mj.id, false, false).then(data => {
      //console.log(data['SfidaLanciateList']);
      //this.sfide[0].sfide = data['SfidaRicevuteList'];
      for (let i = 0; i < data['SfidaLanciateList'].length; i++) {
        let sfida = data['SfidaLanciateList'][i];

        if (sfida.statoSfidante == 'W') {
          this.sfide[1].sfide.push(sfida); //attesa
        }
        else if (sfida.stato == 'W' || sfida.stato == 'A') {
          this.sfide[1].sfide.push(sfida); //in attesa
        }
        else {
          this.sfide[2].sfide.push(sfida); //terminate (vinta, persa, pareggiata, ns)
        }
      }
      for (let i = 0; i < data['SfidaRicevuteList'].length; i++) {

        let sfida = data['SfidaRicevuteList'][i];
        if (sfida.statoSfidato == 'W') {
          this.sfide[0].sfide.push(sfida); //ricevute
        }
        else if (sfida.stato == 'W' || sfida.stato == 'A') {
          this.sfide[1].sfide.push(sfida); //attesa
        }
        else {
          this.sfide[2].sfide.push(sfida); //terminate (vinta, persa, pareggiata, ns)
        }
      }

    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })

  }

  open_lancia_sfida() {
    if (this.lanciasfidaexpand == true)
      this.lanciasfidaexpand = false;
    else
      this.lanciasfidaexpand = true;
  }
  // open_quest(m) {
  //   this.navCtrl.push(Mq_List, { mq_list: m });
  // }

  detail_sfida(sfida, h, i) {

    //console.log(sfida);
    //console.log(h);
    //console.log(i);
    if (i == 0) //appartiene alle sfide ricevute
    {
      //this.open_questionario(microquest);
      this.open_ricevuta(sfida);

    }
    else if (i == 1) //appartiene alle sfide in attesa
    {
      this.navCtrl.push(Mj_Statistiche_Sfida, { 'mj': this.mj, 'sfida': sfida, 'user': this.user });
    }
    else if (i == 2) //appartine alle sfide terminate
    {
      this.navCtrl.push(Mj_Statistiche_Sfida, { 'mj': this.mj, 'sfida': sfida, 'user': this.user });
    }
  }

  lancia_sfida(s, livello_) {
    this.translate.get(['sfide.LANCIASFIDA', 'ATTENZIONE', 'sfide.INSUSERNAME', 'SI', 'ANNULLA', 'sfide.LANCIOSFIDA', 'sfide.INIZIA', 'sfide.NESSUNAVVERSARIO']).subscribe(v => {
      this.presentPopover({}, Select_Button, v['sfide.LANCIASFIDA'], [v['SI'], v['ANNULLA']]).then((risposta) => {
        if (risposta == v['SI']) {
          switch (s) {
            case 'utente':
              if (this.sfidante_username == '') {
                this.showBasicAlert(v['ATTENZIONE'], v['sfide.INSUSERNAME']);
                return;
              }
              this.PostRequest('lanciaSfidaUsername', '', { mqId: this.mqsfida.id, username: this.sfidante_username }, true, true).then((res) => {
                //console.log(res);

                this.open_questionario(res['Sfida']);
              }).catch((e) => {
                console.error(e);
              })

              break;
            case 'random':
              // this.PostRequest('lanciaSfidaRandom', '', { livello: this.livello, mqId: this.mqsfida.id }, true, true).then((res) => {
              this.PostRequest('lanciaSfidaRandom', '', { livello: livello_, mqId: this.mqsfida.id }, true, true).then((res: any) => {
                // console.log(v['sfide.LANCIOSFIDA']);
                var tx_ = '';
                if (this.etheme.theme_selected == 'mygame-theme'){
                  if(res['Sfida'].sfidato.area != null)
                    tx_ = v['sfide.LANCIOSFIDA'] + res['Sfida'].sfidato.nome + ' ' + res['Sfida'].sfidato.cognome + ' - ' + res['Sfida'].sfidato.area;
                  else
                    tx_ = v['sfide.LANCIOSFIDA'] + res['Sfida'].sfidato.nome + ' ' + res['Sfida'].sfidato.cognome;
                }
                else
                  tx_ = v['sfide.LANCIOSFIDA'] + res['Sfida'].sfidato.username;
                if (res['Sfida'].UtenteSfidato_id == null)
                  tx_ = v['sfide.NESSUNAVVERSARIO'];
                this.presentPopover({}, Select_Button, tx_, [v['sfide.INIZIA']], false).then((risposta) => {
                  this.open_questionario(res['Sfida']);
                });
              }).catch((e) => {
                console.error(e);
              })
              break;

          }
        }
      });
    });
  }

  open_ricevuta(m) {
    this.translate.get(['sfide.ACCETTARESFIDA', 'ATTENZIONE', 'sfide.INSUSERNAME', 'SI', 'ANNULLA']).subscribe(v => {
      this.presentPopover({}, Select_Button, v['sfide.ACCETTARESFIDA'], [v['SI'], v['ANNULLA']]).then((livello) => {
        if (livello == v['SI']) {
          this.PostRequest('accettaSfida', m.id, false, false).then((res) => {
            this.open_questionario(res['Sfida']);
          }).catch((err) => {
            console.error(err);
          })
          this.livello = null;

        }

      })
    });
  }
  select_livello(e) {
    this.translate.get(['sfide.SELEZIONALIVELLO', 'sfide.SFIDANORMALE', 'sfide.SFIDADIFFICILE']).subscribe(v => {
      this.presentPopover(e, Select_Button, v['sfide.SELEZIONALIVELLO'], [v['sfide.SFIDANORMALE'], v['sfide.SFIDADIFFICILE']]).then((livello) => {
        if (livello == v['sfide.SFIDANORMALE']) {
          this.livello = 1;
          this.lancia_sfida('random', 1);
        }
        else if (livello == v['sfide.SFIDADIFFICILE']) {
          this.livello = 2;
          this.lancia_sfida('random', 1);
        }

      })
    });
  }
  open_sfida(s, i) {
    //console.log(s);
    //console.log(i);
    if (this.sfide[i].expanded == true)
      this.sfide[i].expanded = false;
    else
      this.sfide[i].expanded = true;


  }

  expandItem(item) {

    this.items.map((listItem) => {

      if (item == listItem) {
        listItem.expanded = !listItem.expanded;
      } else {
        listItem.expanded = false;
      }

      return listItem;

    });

  }
  open_questionario(m) {
    /*if (m.attivo == false) {
      this.showBasicAlert('Alert', 'Sfida non attiva non attivo');
      return;
    }*/
    /*this.presentPopover(event, Confirm, 'Sei sicuro di voler iniziare la sfida ?', 1).then((data) => {
      if (data == 'confirm')*/





    /*});*/
    // this.pagecontent.nativeElement.style.display = 'none';
    this.modalopened = true;
    this.events.publish('modalopened',this.modalopened);
    let profileModal = this.modalCtrl.create(MSteps, { mq: m['MicroQuest_id'], mj: this.mj, sfida: m, livello: this.livello }, { showBackdrop: false, enableBackdropDismiss: false, cssClass: this.etheme.theme_selected });
    profileModal.present();
    profileModal.onDidDismiss((r) => {
      // this.pagecontent.nativeElement.style.display = 'block';
      this.modalopened = false;
      this.events.publish('modalopened',this.modalopened);
      this.refreshpage(this.mj);
      //console.log(r);
    })
    // this.navCtrl.push(MSteps, { mq: m['MicroQuest_id'], mj: this.mj, sfida: m, livello: this.livello });

  }
  back() {
    this.navCtrl.pop({ animate: false });
  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }
  bg_vinta_persa(stato) {
    if (stato == 'V')
      return 'vinta';
    if (stato == 'P')
      return 'persa';
  }
}



// WEBPACK FOOTER //
// ./src/pages/mj_sfida/mj_sfida.ts